import type {components} from "./generated";
import type {AuthorizedFetch} from "./client";

export type FlowTraceView = components["schemas"]["FlowTraceView"];
export type FlowTraceNode = components["schemas"]["FlowTraceNode"];

export async function readFlowTrace(
  fetcher: AuthorizedFetch,
  flowTraceId: string,
  signal?: AbortSignal
): Promise<FlowTraceView> {
  const response = await fetcher(`/api/v1/flow-traces/${encodeURIComponent(flowTraceId)}`, {
    signal,
    headers: {Accept: "application/json"}
  });
  if (!response.ok) {
    const problem = await response.json().catch(() => null) as {message?: string} | null;
    throw new Error(problem?.message ?? `Flow trace read failed: ${response.status}`);
  }
  const result = await response.json() as FlowTraceView;
  if (result.flowTraceId !== flowTraceId || !Array.isArray(result.nodes)) {
    throw new Error("Flow trace response does not match the requested identity");
  }
  return result;
}
